import {
    apiRequest,
    pangkatP3KDetail
} from "../../../../../services/adapters/master/pangkatP3KService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pangkatP3KDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository